import Nullstack from 'nullstack';
export default function IconAperture({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-aperture",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("path", {
    d: "M3.6 15h10.55"
  }), "   ", Nullstack.element("path", {
    d: "M6.551 4.938l3.26 10.034"
  }), "   ", Nullstack.element("path", {
    d: "M17.032 4.636l-8.535 6.201"
  }), "   ", Nullstack.element("path", {
    d: "M20.559 14.51l-8.535 -6.201"
  }), "   ", Nullstack.element("path", {
    d: "M12.257 20.916l3.261 -10.034"
  }), " ");
}